module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "glosa-evidenca"
  }, [_c('table', {
    staticClass: "table table-bordered table-condensed table-hover",
    attrs: {
      "border": "1"
    }
  }, [_c('tbody', [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "titulo-lateral-linha fonte-tabela",
    attrs: {
      "colspan": "1"
    }
  }, [_vm._v("Meses")]), _vm._v(" "), _vm._l((_vm.glosas), function(glosa) {
    return _c('td', {
      staticClass: "meses alinhar-conteudo fonte-tabela"
    }, [_c('strong', [_vm._v(_vm._s(glosa.mes.sigla))])])
  })], 2), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "titulo-lateral-linha fonte-tabela",
    attrs: {
      "colspan": "1"
    }
  }, [_vm._v("Qtde de preventivas não realizadas")]), _vm._v(" "), _vm._l((_vm.glosas), function(item) {
    return _c('td', {
      staticClass: "alinhar-conteudo fonte-tabela"
    }, [(item.quantidade) ? _c('div', [(item.quantidade) ? _c('a', {
      attrs: {
        "href": "javascript:void(0)",
        "data-toggle": "listarGlosas"
      },
      on: {
        "click": function($event) {
          return _vm.listaGlosasPorMes({
            itens: {
              contrato_id: _vm.contratoSelecionado.contrato_id,
              mes: item.mes,
              ano: _vm.anoSelecionado
            }
          })
        }
      }
    }, [_vm._v("\n                      " + _vm._s(item.quantidade) + "\n                  ")]) : _vm._e()]) : (item.quantidade === 0) ? _c('div', [_vm._v("\n                " + _vm._s(item.quantidade) + "\n              ")]) : _vm._e()])
  })], 2), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "titulo-lateral-linha fonte-tabela",
    attrs: {
      "colspan": "1"
    }
  }, [_vm._v("Valor da glosa ")]), _vm._v(" "), _vm._l((_vm.glosas), function(item) {
    return _c('td', {
      staticClass: "alinhar-conteudo fonte-tabela"
    }, [_c('money', _vm._b({
      staticClass: "formatacao-input-exibe-puro-texto",
      attrs: {
        "readonly": ""
      },
      model: {
        value: (item.moeda),
        callback: function($$v) {
          _vm.$set(item, "moeda", $$v)
        },
        expression: "item.moeda"
      }
    }, 'money', _vm.money, false))], 1)
  })], 2)])]), _vm._v(" "), _c('exibir-glosas-impressao', {
    attrs: {
      "filtro": {
        ano: _vm.anoSelecionado,
        contrato: _vm.contratoSelecionado
      }
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "numero-item bg-color-extremidades alinhar-conteudo fonte-tabela",
    attrs: {
      "rowspan": "15"
    }
  }), _vm._v(" "), _c('td', {
    staticClass: "descricao-sla bg-color-extremidades fonte-tabela",
    attrs: {
      "colspan": "15"
    }
  }, [_vm._v("Penalidade por não execução de preventivas ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "detalhe-descricao fonte-tabela",
    attrs: {
      "colspan": "15"
    }
  }, [_c('strong', [_vm._v("Cada preventiva não realizada no prazo, gera glosa no respectivo valor")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-61fabc52!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/glosa/table/TableGlosaEvidencia.vue
// module id = 996
// module chunks = 1